export function getTariffData(axiosPrivate: any, params: any, tariffType: string) {
  let {created_at, created_by} = params

  return axiosPrivate.get(`/master-data/tariff/${tariffType}/${created_at}/${created_by}`)
}

export function approveTariffData(axiosPrivate: any, payload: any) {
  return axiosPrivate.post(`/master-data/approve-tariff`, payload)
}
